module.exports = __webpack_public_path__ + "img/enter_fullscreen_ico.1266b11f.svg";